/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const links = project.getNodeLinks(feature, 'cgg_pub');
    const CGG = project.getFeature('cgg');
    const USERNAME = CGG?.getSettingValue('USERNAME');

    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `#****${doneLinks[0].getSourceId()}****#` : '';

    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        const eventName = project.getNodeParameter(link, 'event_name');
        const data = project.getNodeParameter(link, 'publish_data');

        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
cggInstance.publish(f'devices/{${USERNAME}}/metrics','{${eventName}:${data}}')
${doneBlock}`,
        });
    }
    return blocks;
};
